import { FORTUNE_GROUP_BUYING_AUTH_ERROR } from '@constants'
import { type Middleware } from 'swr'

/**
 * 情境
 * campaign 為團購時，尚未二階段登入的 token 會回傳 403 且 code 為 5950
 * 此時需要跳轉到團購頁面
 */
export const withCampaignGroupBuyingError: Middleware = (useSWRNext) => {
  const isCampaign = window.location.pathname.startsWith('/campaigns')
  /** NOTE: https://beta.buygather.com/campaigns/test 的 split 結果為 ['', 'campaigns', 'test']，所以取第二個 */
  const campaignCodeFromUrl = isCampaign ? window.location.pathname.split('/')[2] : ''
  return (key, fetcher, config) => {
    const swr = useSWRNext(key, fetcher, {
      ...config,
      onError: (...args) => {
        const error = args[0]
        const isLogout = window.location.pathname.includes('/logout')
        const isInLogin = window.location.pathname.includes('/login')
        const isInGroupBuying = window.location.pathname.includes('/group-buying')
        if (error.response?.status === 403 && error.response?.data?.error?.code === FORTUNE_GROUP_BUYING_AUTH_ERROR && !isLogout && !isInGroupBuying && !isInLogin) {
          window.location.href = `${window.location.origin}/campaigns/${campaignCodeFromUrl}/group-buying`
        }
        config?.onError?.(...args)
      },
    })

    return {
      ...swr,
    }
  }
}
